export const FILTER_TOTAL = "total";
export const FILTER_BY_NAME = "name";
export const FILTER_BY_TYPE = "type";
export const FILTER_BY_DIFFICULTIES = "difficulties";
export const FILTER_BY_ABILITY_FONO = "ability_fono";
export const FILTER_BY_ABILITY_PAID = "ability_paid";
export const FILTER_BY_ABILITY_FREE = "ability_free";
export const FILTER_BY_AGE_RANGE = "min_age";
export const FILTER_BY_LANGUAGE = "language";
export const FILTER_ORDER_BY_PUBLICATION_DATE = "publication_date";
export const FILTER_ORDER_BY_POPULARITY = "popularity";
export const FILTER_ORDER_BY_A_TO_Z = "a_to_z";
export const FILTER_ORDER_BY_Z_TO_A = "z_to_a";
export const FILTER_ORDER_BY_HIGHLIGHT = "highlight";

export const FILTER_TYPE_GAME = "game";
export const FILTER_TYPE_AUDIO = "audio";
export const FILTER_TYPE_SOUND = "sound";

// To Analytics
export const FRIENDLY_FILTERS = (input = "???") => {
  switch (input) {
    case FILTER_BY_NAME:
      return "Nome";
    case FILTER_BY_TYPE:
      return "Tipo";
    case FILTER_BY_DIFFICULTIES:
      return "Dificuldade";
    case FILTER_BY_ABILITY_FONO:
      return "Habilidade FONO";
    case FILTER_BY_ABILITY_PAID:
      return "Habilidade PAGA";
    case FILTER_BY_ABILITY_FREE:
      return "Habilidade FREE";
    case FILTER_BY_AGE_RANGE:
      return "Idade";
    case FILTER_BY_LANGUAGE:
      return "Idioma";
    case FILTER_ORDER_BY_PUBLICATION_DATE:
      return "Data de Publicação";
    case FILTER_ORDER_BY_A_TO_Z:
      return "A para Z";
    case FILTER_ORDER_BY_Z_TO_A:
      return "Z para A";
    case FILTER_ORDER_BY_HIGHLIGHT:
      return "Destaques";
    case FILTER_TYPE_GAME:
      return "Jogo";
    case FILTER_TYPE_AUDIO:
      return "Áudio";
    case FILTER_ORDER_BY_POPULARITY:
      return "Popularidade"
    default:
      return input;
  }
};
